window.addEventListener('load', () => {
   
  // Get the root url from the element with the class "route"
  const { textContent: strippedRoute } = document.querySelector('.route');

  // Remove the slash if the root url is empty
  if (strippedRoute === '/') {
    strippedRoute = '';
  }
  
  // Find all links inside the div with the class "shop-path-check"
  document.querySelectorAll('.shop-path-check a').forEach(link => {
    // If the link's href contains "/products"
    if (link.href.includes('/products')) {
      link.href = link.href.replace('/products', `${strippedRoute}/products`);
    }
    // If the link's href contains "/collections"
    if (link.href.includes('/collections')) {
      // Replace "/collections" with "/en-gb/collections"
      link.href = link.href.replace('/collections', `${strippedRoute}/collections`);
    }
    // If the link's href contains "/blogs"
    if (link.href.includes('/blogs')) {
      // Replace "/collections" with "/en-gb/collections"
      link.href = link.href.replace('/blogs', `${strippedRoute}/blogs`);
    }
    // If the link's href contains "/pages"
    if (link.href.includes('/pages')) {
      // Replace "/collections" with "/en-gb/collections"
      link.href = link.href.replace('/pages', `${strippedRoute}/pages`);
    }
    // If the link's href contains "/policies"
    if (link.href.includes('/policies')) {
      // Replace "/collections" with "/en-gb/collections"
      link.href = link.href.replace('/policies', `${strippedRoute}/policies`);
    }
  });
});